import React, { Component } from 'react'
import Box from '@mui/material/Box';
import { Paper, Typography } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import { Link } from 'react-router-dom';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import StoreIcon from '@mui/icons-material/Store';
import GroupsIcon from '@mui/icons-material/Groups';


export class Sidebar extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       first:''
    }
  }
  render() {

    let currentLocation = window.location.pathname

    return (
      <div>
<Paper elevation={1} sx={{display:{xs:'none',sm:'block'},backgroundColor:'#444b52',width:80,minHeight:'93vh',borderRadius:0,position:'static'}}>




<Link to='/dashboard'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/dashboard'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<DashboardOutlinedIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Dashboard</Typography>
</Box> 
</Link>



<Link to='/Orders'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/Orders'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<StoreIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Orders</Typography>
</Box> 
</Link>


<Link to='/settings'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/settings'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<SettingsOutlinedIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Settings</Typography>
</Box> 
</Link>


</Paper>
      </div>
    )
  }
}

export default Sidebar